import { Box, Typography } from '@mui/material'
import React from 'react'

const PopularTags = () => {
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start', py: 2, border: '1px solid #ddd', borderRadius: '16px' }} >
                <Typography color={'secondary.main'} sx={{ px: 2, width: '100%' }} >Popular Tags</Typography>
                <Box sx={{ display:'flex', flexWrap:'wrap', gap:1, alignItems:'center', p:1 }} >
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                    <Typography color={'#1E6FA1'} sx={{ backgroundColor:'#F4F5F5', borderRadius:'8px', p:'2px 8px' }} >
                        Name
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default PopularTags